export default __webpack_public_path__ + "static/media/preface 2.89b41cd4.png";